export default __webpack_public_path__ + "static/media/footer-logo.dc91e6db.png";